"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_EDIT_REASON_VISIBLE_BIT = void 0;
exports.hasPostEdit = hasPostEdit;
exports.buildPostEditFooterBbcode = buildPostEditFooterBbcode;
exports.appendPostEditFooter = appendPostEditFooter;
/** Бит 16 маски поста — причина редактирования видна (Android V0). */
exports.POST_EDIT_REASON_VISIBLE_BIT = 16;
const DEFAULT_SITE_BASE = 'https://4pda.to/';
function escapeBbBrackets(value) {
    return value.replace(/\[/g, '&#91;').replace(/\]/g, '&#93;');
}
function formatEditDate(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    return d.toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
}
/** Пост редактировался (сырой индекс [13] ответа fr не пуст). */
function hasPostEdit(post) {
    return Boolean(post.edit?.date);
}
/**
 * BBCode-хвост «Отредактировал … / Причина: …» как в Android `V0.java` (индексы 13–16).
 * Дописывается к телу поста перед парсингом BBCode.
 */
function buildPostEditFooterBbcode(post, options) {
    const edit = post.edit;
    if (!edit?.date)
        return '';
    const siteBase = options?.siteBase ?? DEFAULT_SITE_BASE;
    const rawName = escapeBbBrackets(String(edit.userName ?? '').trim() || 'Неизвестно');
    let editorPart = rawName;
    if (edit.userId) {
        const profileUrl = `${siteBase}forum/index.php?showuser=${edit.userId}`;
        editorPart = `[url=${profileUrl}]${rawName}[/url]`;
    }
    const dateLabel = formatEditDate(edit.date);
    let block = `[left][sub][color=label_text]\n\nОтредактировал [/color][b]${editorPart}[/b][color=gray] - ${dateLabel}`;
    if ((post.bitmask & exports.POST_EDIT_REASON_VISIBLE_BIT) === 0) {
        block += ' [color=red](Скрыто)[/color]';
    }
    const reason = String(edit.reason ?? '').trim();
    if (reason) {
        block += `\nПричина: ${escapeBbBrackets(reason)}`;
    }
    block += '[/color][/sub][/left]';
    return `[break][NA=1]${block}`;
}
function appendPostEditFooter(content, post, options) {
    const footer = buildPostEditFooterBbcode(post, options);
    if (!footer)
        return content;
    return `${content}${footer}`;
}
